;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('filterUsersDropdown', filterUsersDropdown)

  /* @ngInject */
  function filterUsersDropdown () {
    return {
      restrict: 'E',
      scope: {
        params: '=',
        showFilterButton: '<',
        defaultUsersList: '<',
        countUsers: '<'
      },
      templateUrl: '/core/directives/core-filters/dropdowns/filter-users-dropdown/filter-users-dropdown-directive.html?$$REVISION$$',
      controller: 'FilterUsersDropdownController'
    }
  }
})()
